'use strict';

/* global $ */

let settings = {
    selector: '.js-scroll-to'
};

class ScrollTo {
    constructor(options) {
        this.opt = $.extend({}, settings, options);
        this.init();
    }
    init() {
        console.log('[ ScrollTo/init ]');

        $(document.body).on('click', this.opt.selector, function(e) {
            e.preventDefault();

            let href = $(this).attr('href'),
                $anchor = $(href);

            if ($anchor.length) {
                $('html, body').animate({
                    scrollTop: $anchor.offset().top - 70
                }, 1000);
            }
        });   
    }
}

export {
    ScrollTo
};
